<template>
  <div class="chat-widget" 
       data-fixed-root="true"
       :class="[{ 'minimized': isMinimized, 'hidden': isHidden, 'half-screen-mode': currentState === 'half-screen', 'fullscreen-mode': currentState === 'fullscreen' }, `theme-${currentTheme}`]">
    <!-- 聊天窗口头部 - 修复版本 -->
    <div class="chat-header" @click="toggleMinimize">
      <!-- 顶部行：头像、标题和按钮 -->
      <div class="header-top-row">
        <!-- 左侧：头像和标题 -->
        <div class="header-left">
          <img :src="config.avatar || defaultAssistantAvatar" alt="AI" class="header-avatar">
          <span class="header-title">{{ config.title || 'AI智能客服' }}</span>
        </div>
        
        <!-- 右侧：按钮组 -->
        <div class="header-right">          
          
          <!-- 原有按钮 -->
          <button @click.stop="toggleMinimize" class="header-btn">{{ isMinimized ? '+' : '−' }}</button>
          <button @click.stop="toggleWindowState" class="header-btn state-btn">{{ nextStateIcon }}</button>
          <button @click.stop="closeChat" class="header-btn close-btn">×</button>
        </div>
      </div>
      
      <!-- 横幅区域 -->
      <div class="header-banner">
        <img src="https://aics-public.oss-cn-beijing.aliyuncs.com/images/sunrise_banner.png" 
             alt="横幅" 
             class="banner-image"/>
      </div>
    </div>


    <!-- 聊天内容区域 -->
    <div v-show="!isMinimized" class="chat-content">
      <!-- 消息历史区域 -->
      <div ref="historybox" class="history-container">
        <ul class="message-list">
          <li v-for="item in chathistory" :key="item.id" 
              :class="['message-item', item.role, {
                'timeout-message': item.isTimeoutMessage,
                'rating-invitation': item.isRatingInvitation
              }]">
            
            <!-- 评价邀请消息 -->
            <div v-if="item.role === 'system' && item.isRatingInvitation" 
                class="rating-invitation-message">
              <div class="rating-icon">⭐</div>
              <div class="rating-content">
                <div class="rating-text">{{ item.content }}</div>
                <div class="rating-buttons">
                  <button class="rating-btn good-btn" @click="rateService('good')">
                    👍 满意
                  </button>
                  <button class="rating-btn bad-btn" @click="rateService('bad')">
                    👎 不满意
                  </button>
                </div>
              </div>
            </div>         
            
            <!-- 普通消息 -->
            <template v-else>
              <!-- 助理头像 -->
              <img v-if="item.role === 'assistant'"
                  :src="config.avatar || defaultAssistantAvatar"
                  alt="assistant"
                  class="avatar assistant-avatar" />

              <!-- 加载动画 -->
              <img v-if="item.role === 'assistant' && item.content === '' && !item.formatted"
          src="@/assets/images/loading.gif"
          alt="loading"
          class="avatar loading-indicator" />

              <!-- 消息内容容器 -->
              <div class="message-content-wrapper">
                <div class="message-container" 
                    v-if="item.role === 'assistant' && item.content !== null && !item.content.includes('【系统提示】')">
                    <div class="ai-message-content" @click="handleAiContentClick($event, item)">
                      <!-- 使用自定义指令处理图片 -->
                      <div v-html="processAiContent(item)" />
    </div>
                </div>

                <!-- 用户消息内容 -->
                <span v-if="item.role === 'user' && item.content !== null && !item.content.includes('【系统提示】')"
                      class="content user-message">
                  {{ item.content }}
                  <!-- 显示用户上传的图片 -->
                  <div v-if="item.images && item.images.length > 0" class="message-images">
                    <div v-for="(img, imgIndex) in item.images" :key="imgIndex" class="message-image">
                      <img :src="img" alt="上传的图片"
                      @click="openImageViewer(img, item.images, imgIndex)"
                      class="clickable-image" style="cursor: pointer;"/>
                    </div>
                  </div>
                </span>
                
                <!-- 用户头像 -->
                <img v-if="item.role === 'user' && item.content !== null && !item.content.includes('【系统提示】')"
                    :src="config.userAvatar || defaultUserAvatar"
                    alt="user"
                    class="avatar user-avatar" />
              </div>
            </template>
          </li>
        </ul>
      </div>

      <!-- 输入区域 -->
      <div class="input-container" :class="{ 'has-error': hasError }">
        <textarea 
          :class="(isReady && !isInConversation)?'':'locked'" 
          :disabled="!isReady || isInConversation"
          v-model="msg"
          @keyup.enter="submit"
          :placeholder="placeholderText"
          rows="3"
        ></textarea>
        <a v-if="remainingConversations<100" class="warn-text">
  套餐及加油包余量：{{ remainingConversations }}
</a>
        <!-- 图片上传区域 -->
        <div class="image-upload-container" v-if="!isInConversation">
          <div class="button-bar">
                      <el-button 
            type="plain"
            @click="HandleShowHumanService"
            >
          <svg t="1770461500019" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5590" width="16" height="16"><path d="M791.552 483.84c-128 0-231.936 102.912-231.936 230.4s103.936 230.4 231.936 230.4c128 0 232.448-103.424 231.936-230.4s-103.424-230.4-231.936-230.4z" fill="#5895FF" p-id="5591"></path><path d="M916.992 802.816c-8.704 14.848-27.648 19.456-41.984 11.264l-118.272-68.096c-2.048-1.024-3.584-2.048-5.12-3.584-8.192-6.144-12.8-15.872-12.8-25.6v-87.552c0-17.92 14.848-32.768 33.28-32.768s33.28 14.848 33.28 32.768v73.728l100.864 57.856c14.336 8.192 19.456 27.136 10.752 41.984z" fill="#FFFFFF" p-id="5592"></path><path d="M177.664 270.848C175.104 139.264 280.064 30.72 412.16 28.16s242.176 101.888 244.736 232.96c2.56 131.584-102.4 240.128-235.008 242.688h-5.12c-130.56 1.536-238.08-102.912-239.104-232.96zM482.304 714.24c0-48.128 12.288-93.184 33.28-132.608H309.76C140.288 580.096 1.536 723.456 0 902.656v20.48c0 72.704 138.752 72.704 309.76 72.704H524.8c70.656 0 135.68 0 187.392-5.12-131.072-25.088-229.888-139.264-229.888-276.48z" fill="#5895FF" p-id="5593"></path></svg>
            找人工
          </el-button>    
          <el-button 
            type="plain"
            @click="HandleShowRating"
            >
           <svg t="1765544262044" class="icon" viewBox="0 0 1069 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10104" width="16" height="16"><path d="M584.302281 55.809159C609.97806 129.270416 683.974229 338.777642 683.974229 338.777642h317.916072c69.181961 0 93.787916 43.149573 34.412677 91.29166s-258.540832 209.328922-258.540833 209.328922L874.937837 945.011318c21.218179 66.5074-25.319171 96.462476-68.825352 65.259272S534.912067 817.345638 534.912067 817.345638L264.068257 1010.805502c-50.816646 35.660804-88.260491-8.380289-71.321609-61.693191l98.42382-309.714087L31.0249 429.712694c-44.397702-35.660804-45.824134-92.361484 26.567299-91.469964s326.296361 0 326.296361 0S458.597945 124.812816 481.42086 55.809159c25.675779-75.065993 76.314122-73.639561 101.989901 0z" fill="#FFD200" p-id="10105"></path></svg>            
            评价
          </el-button>                
            <label for="image-upload" class="upload-label btn btn-secondary">              
              <svg t="1765542372750" class="icon" viewBox="0 0 1040 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8915" width="16" height="16"><path d="M986.4068 263.666098l-75.878155 0 0 75.877131c0 20.937868-16.997116 37.936007-37.934984 37.936007-20.945031 0-37.942147-16.999163-37.942147-37.936007l0-75.877131L758.774383 263.666098c-20.942985 0-37.936007-16.999163-37.936007-37.942147 0-20.942985 16.993023-37.934984 37.936007-37.934984l75.877131 0 0-75.878155c0-20.942985 16.997116-37.940101 37.942147-37.940101 20.937868 0 37.934984 16.997116 37.934984 37.940101l0 75.878155 75.878155 0c20.942985 0 37.940101 16.991999 37.940101 37.934984C1024.346901 246.667959 1007.349785 263.666098 986.4068 263.666098L986.4068 263.666098zM758.774383 396.447241c0 31.41243-25.491581 56.909128-56.909128 56.909128-31.413454 0-56.904011-25.497721-56.904011-56.909128s25.490557-56.904011 56.904011-56.904011C733.281779 339.54323 758.774383 365.035834 758.774383 396.447241L758.774383 396.447241zM607.019097 263.666098 75.877131 263.666098l0 528.748453c0.076748-0.265036 83.047438-372.255259 225.244021-372.255259 93.66731 0 188.932 287.689235 248.310366 374.648772 0 0 46.549176-188.480722 126.866433-189.69641 79.44233-1.177825 120.417557 187.301873 120.417557 187.301873l37.936007 0L834.651514 567.175647c0-20.942985 16.997116-37.942147 37.942147-37.942147 20.937868 0 37.934984 16.999163 37.934984 37.942147l0 303.509549c0 41.919738-33.989115 75.877131-75.877131 75.877131L75.877131 946.562327c-41.919738 0-75.877131-33.957393-75.877131-75.877131L0 263.666098c0-41.924855 33.957393-75.877131 75.877131-75.877131l531.141966 0c20.942985 0 37.942147 16.991999 37.942147 37.934984C644.961244 246.667959 627.962082 263.666098 607.019097 263.666098L607.019097 263.666098zM607.019097 263.666098" fill="#1296db" p-id="8916"></path></svg>
              传图片
            </label>
            <button v-if="isReady && !isInConversation && remainingConversations>100" class="btn btn-primary" @click="submit" title="按回车键发送消息">
              <svg t="1765544445855" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11218" width="16" height="16"><path d="M111.76 412.98L864.43 99.34c8.17-3.4 17.56-1.91 24.27 3.86a23.407 23.407 0 0 1 7.45 23.41L708.66 876.59a23.409 23.409 0 0 1-15.45 16.56c-7.65 2.5-16.05 0.88-22.23-4.27L508.19 753.24c-9.31-7.75-22.99-7.11-31.54 1.46l-83.5 83.44a23.407 23.407 0 0 1-25.45 5.03 23.393 23.393 0 0 1-14.46-21.53V645.28c0-6.21 2.46-12.16 6.85-16.56l339.56-339.56-400.88 300.71c-8.68 6.5-20.7 6.19-29.02-0.76L105.79 452.53a23.405 23.405 0 0 1-8.14-21.45 23.422 23.422 0 0 1 14.11-18.1z m0 0" p-id="11219" fill="#ffffff"></path></svg>
              发送
            </button>
            <button v-else  @click="submit"  class="btn plain" title="AI客服套餐余量不足">
              <svg t="1786863262960" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5641" width="16" height="16"><path d="M512 206.144l396.992 687.552L115.008 893.696 512 206.144M512 70.912 0 957.696l1024 0L512 70.912 512 70.912 512 70.912zM512 66.304M480 381.696l64 0 0 320-64 0L480 381.696 480 381.696zM544 765.696l0 64-64 0 0-64M480 765.696" fill="#d81e06" p-id="5642"></path></svg>
              发送
            </button>
            <button v-if="isInConversation" class="btn btn-accent" @click="stop" title="结束对话">
              <svg t="1756477905919" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7349" width="16" height="16">
                <path d="M128 128m170.666667 0l426.666666 0q170.666667 0 170.666667 170.666667l0 426.666666q0 170.666667-170.666667 170.666667l-426.666666 0q-170.666667 0-170.666667-170.666667l0-426.666666q0-170.666667 170.666667-170.666667Z" fill="#ffffff" p-id="7350"></path>
              </svg>
              结束
            </button>
          </div>
          
          <input
            type="file"
            id="image-upload"
            accept="image/*"
            multiple
            @change="handleImageUpload"
            style="display: none;"
          >

          <!-- 图片预览区域 -->
          <div class="image-previews" v-if="uploadedImages.length > 0">
            <div v-for="(image, index) in uploadedImages" :key="index" class="image-preview">
              <img :src="image.preview" alt="预览图"
             @click="openPreviewImage(image.preview, index)"
              class="clickable-image">
              <button class="remove-image" @click="removeImage(index)">×</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 图片查看器模态框 -->
<div v-if="imageViewer.visible" class="image-viewer-modal" @click.self="closeImageViewer">
  <div class="image-viewer-content" @click.stop> <!-- 添加这行 -->
    <button class="close-btn" @click.stop="closeImageViewer"> <!-- 添加 .stop -->
      <svg viewBox="0 0 24 24" width="24" height="24">
        <path fill="currentColor" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"/>
      </svg>
    </button>

    <button v-if="imageViewer.imageList.length > 1" 
            class="nav-btn prev-btn" 
            @click.stop="showPrevImage"> <!-- 添加 .stop -->
      <svg viewBox="0 0 24 24" width="24" height="24">
        <path fill="currentColor" d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z"/>
      </svg>
    </button>

    <button v-if="imageViewer.imageList.length > 1" 
            class="nav-btn next-btn" 
            @click.stop="showNextImage"> <!-- 添加 .stop -->
      <svg viewBox="0 0 24 24" width="24" height="24">
        <path fill="currentColor" d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"/>
      </svg>
    </button>

    <div class="image-container" @click.stop> <!-- 添加 .stop -->
      <img :src="imageViewer.currentImage" alt="查看图片" 
           @load="onImageLoad" 
           @error="onImageError"
           @click.stop> <!-- 添加 .stop -->
      <div v-if="isImageLoading" class="loading-indicator">
        <div class="spinner"></div>
      </div>
    </div>

    <div v-if="imageViewer.imageList.length > 1" class="thumbnail-nav" @click.stop> <!-- 添加 .stop -->
      <div
        v-for="(img, index) in imageViewer.imageList"
        :key="index"
        :class="['thumbnail', { active: index === imageViewer.currentIndex }]"
        @click.stop="switchImage(index)"
      >
        <img :src="getThumbnailUrl(img)" alt="缩略图">
      </div>
    </div>

    <div class="image-info" @click.stop> <!-- 添加 .stop -->
      <span>{{ imageViewer.currentIndex + 1 }} / {{ imageViewer.imageList.length }}</span>
      <a v-if="imageViewer.currentImage" 
         :href="imageViewer.currentImage" 
         download 
         target="_blank" 
         class="download-btn"
         @click.stop> <!-- 添加 .stop -->
        下载原图
      </a>
    </div>
  </div>
</div>
    <!-- 找人工组件 -->
    <HumanService
      v-if="showHumanService"
      :show="showHumanService"
      :workspaceSlug="this.slug"
      @submitted="onHumanServiceSubmitted"
      @skipped="onFeedbackSkipped"      
      @close="closeHumanService"
    />       
    <!-- 用户评价组件 -->
    <UserRating
      v-if="showRating"
      :show="showRating"
      :conversation-info="ratingConversationInfo"
      :workspaceSlug="this.slug"
      @submitted="onFeedbackSubmitted"
      @skipped="onFeedbackSkipped"      
      @close="closeRating"
    />   
    <!-- AI图片查看器模态框 -->
    <div v-if="aiImageViewer.visible" class="image-viewer-modal ai-image-viewer" @click.self="closeAiImageViewer">
      <div class="image-viewer-content" @click.stop>
        <button class="close-btn" @click.stop="closeAiImageViewer">
          <svg viewBox="0 0 24 24" width="24" height="24">
            <path fill="currentColor" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"/>
          </svg>
        </button>

        <button v-if="aiImageViewer.imageList.length > 1" 
                class="nav-btn prev-btn" 
                @click.stop="showAiPrevImage">
          <svg viewBox="0 0 24 24" width="24" height="24">
            <path fill="currentColor" d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z"/>
          </svg>
        </button>

        <button v-if="aiImageViewer.imageList.length > 1" 
                class="nav-btn next-btn" 
                @click.stop="showAiNextImage">
          <svg viewBox="0 0 24 24" width="24" height="24">
            <path fill="currentColor" d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"/>
          </svg>
        </button>

        <div class="image-container" @click.stop>
          <img :src="aiImageViewer.currentImage" alt="AI生成的图片" 
              @load="onImageLoad" 
              @error="onImageError"
              @click.stop>
          <div v-if="isImageLoading" class="loading-indicator">
            <div class="spinner"></div>
          </div>
        </div>

        <div v-if="aiImageViewer.imageList.length > 1" class="thumbnail-nav" @click.stop>
          <div
            v-for="(img, index) in aiImageViewer.imageList"
            :key="index"
            :class="['thumbnail', { active: index === aiImageViewer.currentIndex }]"
            @click.stop="switchAiImage(index)"
          >
            <img :src="getThumbnailUrl(img)" alt="缩略图">
          </div>
        </div>

        <div class="image-info" @click.stop>
          <span>{{ aiImageViewer.currentIndex + 1 }} / {{ aiImageViewer.imageList.length }}</span>
          <a v-if="aiImageViewer.currentImage" 
            :href="aiImageViewer.currentImage" 
            download 
            target="_blank" 
            class="download-btn"
            @click.stop>
            下载原图
          </a>
        </div>
      </div>
    </div>  
  </div>
</template>

<script>
import { newThread, sendStreamChatRequest } from '@/api/chat/chat';
import { imageProcessorAsync } from '/public/utils/processors';
import { LOCAL_API_URL, http } from "@/api/base";
import {
  initWebSocket,
  registerCallback,
  unregisterCallback,
  closeWebSocket,
  getConnectionState,
  waitForConnection,
  attemptReconnect
} from '@/api/chat/websocket';
import {  /*load_my_fuel_package,*/ countRemaingMessages } from '@/api/tenant/plan'
// 引入用户评价组件
import UserRating from '@/components/chat/UserRating.vue';
// 引入找人工组件
import HumanService from '@/components/chat/HumanService.vue';

// 高亮显示代码
import hljs from 'highlight.js'
import 'highlight.js/styles/github.css'
import javascript from 'highlight.js/lib/languages/javascript'
import json from 'highlight.js/lib/languages/json'
import { BASE_PROCESSORS, createCodeProcessor } from '/public/utils/processors';
import {getChatConfig} from '@/api/chat/chatWidget';

// 引入主题配置
import { themes } from '/public/utils/themes';

// 注册语言
hljs.registerLanguage('javascript', javascript)
hljs.registerLanguage('json', json)

export default {
  name: 'ChatWidget',
  components: {
    UserRating,
    HumanService
  },  
  props: {
    // 方式一：通过UUID获取配置
    configUuid: {
      type: String,
      default: ''
    },
    tenantId:{
      type: Number,
      default:0
    },
    username:{
      type: String,
      default: ''
    }
  },

  data() {
    return {
      config: {},
      hasWelcomed: false,
      msg: '',
      errorMessage: '',
      hasError: false,
      keyboardHandler: null,
      isUploading: false,
      uploadProgress: 0,
      timer: null,
      debounceTimer: null,
      chathistory: [],
      firstMessageContent: '', // 存储第一条消息内容
      aiSeatId: 1,
      slug: "test",
      threadSlug: "",
      mode: "chat",
      isReady: false,
      isStopped: false,
      isInConversation: true,
      remainingConversations: 0,
      showRating: false,
      showHumanService: false,
      ratingForm:{
        workSpaceSlug:'',
        threadSlug: '',      
      },
 // ======think 标签状态机 ==========
    thinkState: {
      inside: false,      // 是否在 <think> 标签内
      buffer: ''          // 缓冲的未处理内容
    },
    // ========== 结束 ==========         
            // AI输出图片查看器
        aiImageViewer: {
          visible: false,
          currentImage: '',
          currentIndex: 0,
          imageList: []
        },  
      isProcessingSystemEnd: false, // CONVERSATION_END 状态标记

      pendingSystemEndMessage: null,
      CONTENT_PROCESSORS: {
        ...BASE_PROCESSORS,
        ...createCodeProcessor(this._highlightCode)
      },
      pendingCodeBlocks: new Set(),
      codeHighlightTimer: null,
      updateReply: null,
      currentTheme: 'default',
      themes: themes,
      showThemeSelector: true,
      formatTimeout: null,
      uploadedImages: [],
      maxImageSize: 5 * 1024 * 1024,
      
      // 窗口状态
      isMinimized: false,
      isHidden: false,  
      windowStates: ['default', 'half-screen', 'fullscreen'], // 三种状态
      currentStateIndex: 0, // 当前状态索引      
      // 图片查看器
      imageViewer: {
        visible: false,
        currentImage: '',
        currentIndex: 0,
        imageList: [],
        reconnectAttempts: 0,
        maxReconnectAttempts: 5,
        reconnectDelay: 1000,
        isServiceUnavailable: false,
        reconnectTimer: null
      },
      
      // 默认头像
      defaultAssistantAvatar: require('@/assets/images/service_logo.png'),
      defaultUserAvatar: require('@/assets/images/user_logo.png')
    }
  },

  computed: {
        tenantInfo() {
      return this.$store.getters['auth/currentTenant'];
    },
    placeholderText() {
      if(this.isStopped) return '对话已停止...';
      if(!this.isReady) return '正在连接服务器...';
      return this.isInConversation ? '对话已锁定...' : '请输入您的问题...';
    },
    
    // 合并配置
    mergedConfig() {
      return {
        aiSeatId: this.config.aiSeatId || this.aiSeatId,
        slug: this.config.kbWorkspaceSlug || this.slug,
        title: this.config.title || 'AI智能客服',
        theme: this.config.theme || 'default',
        avatar: this.config.avatar || this.defaultAssistantAvatar,
        userAvatar: this.config.userAvatar || this.defaultUserAvatar,
        showThemeSelector: this.config.showThemeSelector !== undefined ? this.config.showThemeSelector : false
      };
    },
    // 状态相关计算属性
    currentState() {
      return this.windowStates[this.currentStateIndex];
    },    
    // 根据状态返回对应的图标
    stateIcon() {
      const icons = {
        'default': '⎙',      // 默认状态图标
        'half-screen': '⬌',  // 半屏图标
        'fullscreen': '⤢'    // 全屏图标
      };
      return icons[this.currentState] || '⎙';
    },    
    // 状态切换提示
    stateTitle() {
      const titles = {
        'default': '默认窗口',
        'half-screen': '半屏模式',
        'fullscreen': '全屏模式'
      };
      return titles[this.currentState] || '切换窗口状态';
    },
    // 获取下一个状态索引
    nextStateIndex() {
      return (this.currentStateIndex + 1) % this.windowStates.length;
    },
    
    // 下一个状态
    nextState() {
      return this.windowStates[this.nextStateIndex];
    },
    
    // 根据下一个状态返回对应的图标
    nextStateIcon() {
      const icons = {
        'default': '⎙',      // 默认状态图标
        'half-screen': '⬌',  // 半屏图标
        'fullscreen': '⤢'    // 全屏图标
      };
      return icons[this.nextState] || '⎙';
    },
    
    // 下一个状态的提示
    nextStateTitle() {
      const titles = {
        'default': '切换为默认窗口',
        'half-screen': '切换为半屏模式',
        'fullscreen': '切换为全屏模式'
      };
      return titles[this.nextState] || '切换窗口状态';
    },
    
    // 当前状态的描述（可选，用于其他用途）
    currentStateDesc() {
      const descs = {
        'default': '默认窗口',
        'half-screen': '半屏模式',
        'fullscreen': '全屏模式'
      };
      return descs[this.currentState] || '默认窗口';
    }

  },  

  watch: {
    chathistory: {
        deep: true,
        handler(newVal, oldVal) {
          const contentChanged = newVal.some((item, index) => {
            return !oldVal[index] || item.content !== oldVal[index].content;
          });

          if (contentChanged) {
            this.chathistory.forEach((item, index) => {
              if (item.role === 'assistant' && item.content && !item.formatted) {
                const formatted = this.formatContent(item.content);
                this.$set(this.chathistory[index], 'formatted', formatted);
              }
            });
            
            // ✅ 新增：异步处理图片
            this.resolveImagesAsync();
          }

          this.$nextTick(() => {
            const container = this.$refs.historybox;
            if (container) {
              container.scrollTop = container.scrollHeight;
            }
            this.highlightAllCodeBlocks();
          });
        }
    },

    currentTheme(newTheme) {
      document.documentElement.setAttribute('data-theme', newTheme);
    },

    // 监听配置变化
    'config.theme': {
      handler(newTheme) {
        if (newTheme) {
          this.currentTheme = newTheme;
        }
      },
      immediate: true
    }
  },
  async mounted() {
     this.get_remaining_message_count();

console.log('所有props:', {
  configUuid: this.configUuid,
  tenantId: this.tenantId,
  username: this.username
});
    console.log("this.username", this.username)
    console.log(this.configUuid)
    getChatConfig(this.configUuid).then(res =>{
      console.log(res);
      if(res.data.code==200){
        this.config = res.data.data.config_data        
        this.init()
      }
      else{
        this.$message.error("获取配置数据失败")
      }
      console.log(this.config);
    });
    this.setupCopyButtons();
    this.$nextTick(() => {
      document.querySelectorAll('pre code').forEach((block) => {
        hljs.highlightBlock(block);
      });
    });
  // 添加窗口大小变化监听
  window.addEventListener('resize', this.handleResize);    
  },

  beforeDestroy() {
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer);
    }
    if (this.updateReply) {
      unregisterCallback(this.threadSlug, this.updateReply);
    }
    closeWebSocket(this.threadSlug);
    this.removeKeyboardEvents();
    this.hasError = false;
    this.errorMessage = '';
    //移除监听
    window.removeEventListener('resize', this.handleResize);    
  },

  updated() {
      this.$nextTick(() => {
        document.querySelectorAll('pre code:not(.hljs)').forEach((block) => {
          hljs.highlightBlock(block);
        });
        this.setupCopyButtons();
        // 强制为AI消息中的图片设置手型光标
        this.forceSetImageCursor();
      });
  },

  methods: {
    async resolveImagesAsync() {
    // 找到所有还未处理图片的 assistant 消息
    const pendingMessages = this.chathistory.filter(
      item => item.role === 'assistant' 
        && item.formatted 
        && !item._imagesResolved  // 标记位
        && /!\[.*?\]\(.*?\)/.test(item.formatted)  // 还有 markdown 图片语法
    );

    for (const item of pendingMessages) {
      try {
        const processed = await imageProcessorAsync(item.formatted);
        // 用 $set 触发响应式更新
        this.$set(item, 'formatted', processed);
        this.$set(item, '_imagesResolved', true);
      } catch (e) {
        console.error('异步图片处理失败:', e);
        this.$set(item, '_imagesResolved', true);  // 防止无限重试
      }
    }
    },
    
    async init() {
      console.log("=== init()开始 ===");
      console.log("1. 获取配置完成:", this.config);
      
      // 确保配置完全应用
      await this.$nextTick();
      
      // 使用 mergedConfig 确保取值
      this.aiSeatId = this.mergedConfig.aiSeatId;
      this.slug = this.mergedConfig.slug;
      
      console.log("2. 配置应用完成:", {
        aiSeatId: this.aiSeatId,
        slug: this.slug,
        config: this.config,
        mergedConfig: this.mergedConfig
      });

      try {
        console.log("3. 开始创建线程 newThread...");
        const response = await newThread(this.slug);
        console.log("4. 线程创建响应:", response);
        
        this.threadSlug = response.thread.slug;
        console.log("5. threadSlug设置:", this.threadSlug);
        
        // 再次验证参数
        console.log("6. 最终参数验证:", {
          threadSlug: this.threadSlug,
          aiSeatId: this.aiSeatId,
          slug: this.slug
        });
        
        // 延迟确保所有数据都已设置
        await new Promise(resolve => setTimeout(resolve, 100));
        
        console.log("7. 调用 initializeWebSocket...");
        await this.initializeWebSocket();
        
      } catch (error) {
        console.error("init()出错:", error);
      }
    }, 
    get_remaining_message_count(){
       // 加载套餐用量
      console.log("start to call get_remaining_message_count()");
     countRemaingMessages( this.tenantId)
  .then(response_use_messages => {
    // 在这里处理返回的数据
    console.log("套餐用量结果:", response_use_messages);
    // 赋值给 data 中的变量
    this.remainingConversations = Number(response_use_messages.data)>0?
     Number(response_use_messages.data):0;    
    alert(" this.remainingConversations:"+ this.remainingConversations)
  })
  .catch(error => {
    console.error("获取套餐用量失败:", error);
  });
    },
    // 窗口控制方法
toggleMinimize() {
  this.isMinimized = !this.isMinimized;
  
  // 如果是最小化状态，移除其他状态
  if (this.isMinimized) {
    this.$el.classList.remove('half-screen-mode', 'fullscreen-mode');
  } else {
    // 恢复之前的状态
    this.applyWindowState();
  }
},

    closeChat() {
      this.isHidden = true;
      this.$emit('close');
    },

    openChat() {
      this.isHidden = false;
      this.isMinimized = false;
    },

    async sendWelcomeMessage() {
      console.log("发送欢迎语，当前状态:", {
        isInConversation: this.isInConversation,
        hasWelcomed: this.hasWelcomed
      });
      
      this.chathistory.push({
        id: this.chathistory.length + 1,
        role: "assistant",
        content: "正在连接中..."
      });

      await new Promise(resolve => setTimeout(resolve, 300));

      const welcomeRequest = {
        aiSeatId: this.aiSeatId,
        workspaceSlug: this.slug,
        message: "【系统提示】请说欢迎语",
        threadSlug: this.threadSlug,
        reset: false,
        mode: "chat",
      };

      // 发送欢迎请求时不锁定，或者只在开始时短暂锁定
      // 开场白应该很快完成
      this.isInConversation = true; 
      
      console.log("发送欢迎请求");
      sendStreamChatRequest(welcomeRequest);
    },

    handleImageUpload(event) {
      console.log('handleImageUpload called', event.target.files);
      const files = event.target.files;
      if (!files || files.length === 0) {
        console.log('No files selected');
        return;
      }

      const totalAfterUpload = this.uploadedImages.length + files.length;
      if (totalAfterUpload > 6) {
        this.$message.error('每天最多上传6张图片');
        event.target.value = '';
        return;
      }

      const promises = [];
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        console.log('Processing file:', file.name, file.type, file.size);

        if (!file.type.startsWith('image/')) {
          this.$message.error('请上传图片文件');
          continue;
        }

        if (file.size > this.maxImageSize) {
          this.$message.error('图片大小不能超过5MB');
          continue;
        }

        const promise = new Promise((resolve) => {
          const reader = new FileReader();
          reader.onload = (e) => {
            console.log('FileReader loaded:', file.name);
            resolve({
              file: file,
              preview: e.target.result,
              name: file.name
            });
          };
          reader.onerror = (error) => {
            console.error('FileReader error:', error);
            this.$message.error('图片读取失败');
            resolve(null);
          };
          reader.readAsDataURL(file);
        });
        promises.push(promise);
      }

      Promise.all(promises).then((newImages) => {
        const validImages = newImages.filter(img => img !== null);
        if (validImages.length > 0) {
          console.log('Adding new images:', validImages.length);
          this.uploadedImages = [...this.uploadedImages, ...validImages];
          console.log('Total images now:', this.uploadedImages.length);
        }
      });

      event.target.value = '';
    },

    removeImage(index) {
      this.uploadedImages.splice(index, 1);
    },

    clearAllImages() {
      this.uploadedImages = [];
    },

    // 确保 debounceUpdate 能处理HTML内容
    debounceUpdate(content) {
      // 清除之前的定时器
      clearTimeout(this.updateTimer);
      
      // 设置新的定时器
      this.updateTimer = setTimeout(() => {
        // 找到最后一条助手消息
        const lastAssistantMsg = this.chathistory
          .filter(msg => msg.role === 'assistant')
          .pop();
        
        if (lastAssistantMsg) {
          // 先过滤思维链
          let cleanContent = content;
          if (typeof content === 'string') {
            // 使用正则过滤 <think> 标签
            cleanContent = content.replace(/<think>[\s\S]*?<\/think>/gi, '');
            cleanContent = cleanContent.trim();
          }
          
          // 检查是否为HTML内容
          const isHtmlContent = cleanContent && (cleanContent.includes('<img') || cleanContent.includes('<div'));
          
          // 如果是HTML内容，直接设置formatted字段
          if (isHtmlContent) {
            console.log("更新HTML内容");
            lastAssistantMsg.formatted = cleanContent;
          } else {
            // 原有的流式更新逻辑
            lastAssistantMsg.content = cleanContent;
          }
          
          // 触发视图更新
          this.$forceUpdate();
          
          // 滚动到底部
          this.$nextTick(() => {
            const container = this.$refs.historybox;
            if (container) {
              container.scrollTop = container.scrollHeight;
            }
          });
        }
      }, 50);
    },

    async uploadImageToOSS(file) {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('threadId', this.threadSlug);

      const response = await http.post(
        `${LOCAL_API_URL}/api/chat/upload-image`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      console.log('图片上传成功:', response.data.url);
      return response.data.url;
    },

    handleError(error) {
      console.error("处理错误:", error);
      
      // 更精确的错误分类
      if (error.includes('认证') || error.includes('session') || error.includes('未授权')) {
        this.$message.error('会话已过期，请刷新页面重新连接');
        this.handleSessionExpired();
      } else if (error.includes('连接') || error.includes('网络')) {
        this.$message.error('网络连接异常，正在尝试重连...');
        this.reconnectWebSocket();
      } else {
        this.$message.error(`操作失败: ${error}`);
      }
      
      this.hasError = true;
      this.errorMessage = error;
      this.isInConversation = false;
    },

registerCallback() {
  this.updateReply = (content, isCompleted = false, error = null) => {
    console.log("收到回调:", { 
      contentLength: content ? content.length : 0, 
      isCompleted, 
      error,
      isInConversation: this.isInConversation,
      hasWelcomed: this.hasWelcomed
    });    

    // ========== 状态机过滤 <think> 标签（支持跨 chunk）==========
    let cleanedContent = '';
    
    if (content && typeof content === 'string') {
      // 确保 thinkState 存在
      if (!this.thinkState) {
        this.thinkState = { inside: false, buffer: '' };
      }
      
      // 将新内容添加到缓冲区
      this.thinkState.buffer += content;
      
      // 处理缓冲区
      let i = 0;
      while (i < this.thinkState.buffer.length) {
        if (!this.thinkState.inside) {
          // 不在 think 标签内，查找 <think
          const thinkStart = this.thinkState.buffer.toLowerCase().indexOf('<think', i);
          
          if (thinkStart === -1) {
            // 没有找到开始标签，输出剩余所有内容
            cleanedContent += this.thinkState.buffer.substring(i);
            this.thinkState.buffer = '';
            break;
          } else {
            // 找到开始标签，输出标签前的内容
            cleanedContent += this.thinkState.buffer.substring(i, thinkStart);
            // 截断缓冲区，保留标签开始部分
            this.thinkState.buffer = this.thinkState.buffer.substring(thinkStart);
            this.thinkState.inside = true;
            i = 0;
          }
        } else {
          // 在 think 标签内，查找 </think>
          const thinkEnd = this.thinkState.buffer.toLowerCase().indexOf('</think>', i);
          
          if (thinkEnd === -1) {
            // 没有找到结束标签，保留缓冲区等待下一个 chunk
            // 不输出任何内容（丢弃标签内的所有内容）
            break;
          } else {
            // 找到结束标签，跳过标签内的内容
            this.thinkState.buffer = this.thinkState.buffer.substring(thinkEnd + 8); // 8 = '</think>'.length
            this.thinkState.inside = false;
            i = 0;
          }
        }
      }
      
      // 清理多余的空白
      cleanedContent = cleanedContent.trim();
      
      if (cleanedContent !== content) {
        console.log('🧹 已过滤 <think> 标签内容');
        console.log('   原始内容:', content.substring(0, 100));
        console.log('   过滤后:', cleanedContent.substring(0, 100) || '(空)');
      }
    } else {
      cleanedContent = content;
    }
    // ========== 状态机过滤结束 ==========

    if (error) {
      console.error("收到错误:", error);
      // 移除刚才添加的历史记录
      if (this.chathistory.length >= 2) {
        this.chathistory.pop();
        this.chathistory.pop();
      }
      this.handleError(error);
      return;
    }

    // 处理CONVERSATION_TIMEOUT消息（超时未响应）    
    if (isCompleted === 'conversation_timeout') {
      console.log("收到完整的对话结束消息（用户超时未响应）");
      const conversation_timeout_processed_obj = JSON.parse(cleanedContent);
      console.log("conversation_timeout_processed_obj", conversation_timeout_processed_obj);
      const replyObj = JSON.parse(conversation_timeout_processed_obj.reply);
      console.log("解析成功:", replyObj);
      const userMessage = replyObj.reply || "感谢您的咨询！";
      
      const hasTimeoutMessage = this.chathistory.some(item => item.isTimeoutMessage);
      const hasRatingInvitation = this.chathistory.some(item => item.isRatingInvitation);
      
      if (hasTimeoutMessage || hasRatingInvitation) {
        console.log("已经处理过CONVERSATION_TIMEOUT消息，跳过重复处理");
        return;
      }
      
      this.chathistory.push({
        id: Date.now(),
        role: "assistant",
        content: userMessage,
        isTimeoutMessage: true,
        timestamp: new Date()
      });
      
      this.showUserRating(replyObj)

      this.isInConversation = false;
      this.isUploading = false;
      
      this.$nextTick(() => {
        const container = this.$refs.historybox;
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      });
      
      return;
    }

    // 处理最终完成的情况
    if (isCompleted === true) {
      console.log("对话已完成，解除锁定");
      
      // ========== 重置 think 状态机 ==========
      if (this.thinkState) {
        this.thinkState = { inside: false, buffer: '' };
      }
      // ========== 重置结束 ==========
      
      this.isInConversation = false;
      this.isUploading = false;
      
      // 检查是否为HTML内容
      const isHtmlContent = cleanedContent && (cleanedContent.includes('<img') || cleanedContent.includes('<div'));
      console.log("是否为HTML内容:", isHtmlContent);
      
      const lastMessageIndex = this.chathistory.length - 1;
      if (lastMessageIndex >= 0 && this.chathistory[lastMessageIndex].role === 'assistant') {
        // 移除或更新最后一条消息（如果它正在loading）
        if (this.chathistory[lastMessageIndex].content === '') {
          // 如果最后一条是空的loading消息，更新它
          if (isHtmlContent) {
            console.log("设置HTML内容到formatted字段");
            this.chathistory[lastMessageIndex].content = cleanedContent;
            this.chathistory[lastMessageIndex].formatted = cleanedContent;
          } else {
            this.chathistory[lastMessageIndex].content = cleanedContent;
          }
        } else {
          // 如果已经有内容，更新它
          const currentMsg = this.chathistory[lastMessageIndex];
          if (isHtmlContent) {
            currentMsg.content = cleanedContent;
            currentMsg.formatted = cleanedContent;
          } else {
            currentMsg.content = cleanedContent;
          }
        }
        
        // 强制更新视图
        this.$forceUpdate();
        
        this.$nextTick(() => {
          const container = this.$refs.historybox;
          if (container) {
            container.scrollTop = container.scrollHeight;
          }
          // 确保高亮代码块
          this.highlightAllCodeBlocks();
        });
      }
    } 
    // 处理流式更新（普通内容）
    else if (cleanedContent) {
      console.log("流式更新内容");
      this.debounceUpdate(cleanedContent);
    }
  };

  registerCallback(this.threadSlug, this.updateReply);
  console.log("回调注册完成");
  
  if (!this.hasWelcomed) {
    this.sendWelcomeMessage().then(() => {
      this.hasWelcomed = true;
    });
  }
},

      // WebSocket初始化方法
    async initializeWebSocket() {
      console.log("=== initializeWebSocket()开始 ===");
      
      if (this.isServiceUnavailable || this.reconnectAttempts >= this.maxReconnectAttempts) {
        console.log("跳过: 服务不可用或已达最大重试次数");
        return;
      }

        console.log("1. 准备初始化WebSocket参数:", {
          threadSlug: this.threadSlug,
          aiSeatId: this.aiSeatId,
          slug: this.slug
        });

        // 初始化WebSocket
        console.log("2. 调用 initWebSocket...",this.threadSlug, this.aiSeatId, this.slug);
         
  // 确保参数已正确设置
  console.log("参数检查:", {
    threadSlug: this.threadSlug,
    aiSeatId: this.aiSeatId,
    slug: this.slug,
    mergedConfig: this.mergedConfig
  });
  
  // 验证参数不为空
  if (!this.threadSlug || !this.aiSeatId || !this.slug) {
    console.error("参数不完整，等待重试...");
    setTimeout(() => this.initializeWebSocket(), 1000);
    return;
  }
  
  try {
    console.log("初始化WebSocket参数:", {
      threadSlug: this.threadSlug,
      aiSeatId: this.aiSeatId,
      workspaceSlug: this.slug  // 注意：这里使用 this.slug
    });
    
    // 调用时明确参数名
    initWebSocket(this.threadSlug, this.aiSeatId, this.slug);

        // 检查连接状态
        const state = getConnectionState(this.threadSlug);
        console.log("3. 连接状态:", state);

        // 设置超时
        const timeout = Math.min(3000 + this.reconnectAttempts * 1000, 10000);
        console.log("4. 等待连接建立，超时:", timeout, "ms");
        
        // 等待连接建立
        await waitForConnection(this.threadSlug, timeout);
        console.log("5. WebSocket连接成功");

        // 重置重试计数
        this.reconnectAttempts = 0;
        this.reconnectDelay = 1000;
        this.isServiceUnavailable = false;

        console.log("6. 调用 registerCallback...");
        // 注册回调
        this.registerCallback();

        console.log("7. 设置状态为就绪");
        this.isReady = true;
        this.isStopped = false;
        
        console.log("8. initializeWebSocket()完成");

      } catch (error) {
        console.error("initializeWebSocket出错:", error);
        this.handleError(`连接失败: ${error.message}`);

        // 重试逻辑...
      }
    },
    async checkConnectionStatus() {
      const state = getConnectionState(this.threadSlug);
      console.log('当前连接状态:', state);
      
      return new Promise((resolve) => {
        setTimeout(() => {
          // 基于现有WebSocket状态判断，无需后端接口
          resolve(state === '已连接');
        }, 1000);
      });
    },    
    // 移除空的助手消息
     removeEmptyAssistantMessage() {
      console.log("移除刚才添加的历史记录..",this.chathistory);
      if (this.chathistory.length > 0 &&
          this.chathistory[this.chathistory.length - 1].role === 'assistant' &&
          this.chathistory[this.chathistory.length - 1].content === '') {
        this.chathistory.pop();
      }
    },
    // 重连WebSocket
    async reconnectWebSocket() {
      console.log("尝试重新连接WebSocket...");

      // 先取消注册旧回调
      if (this.updateReply) {
        unregisterCallback(this.threadSlug, this.updateReply);
      }

      // 关闭旧连接
      closeWebSocket(this.threadSlug);

      // 重新初始化
      attemptReconnect(this.threadSlug);
      //await this.initializeWebSocket();
    },

    async submit() {        
      this.get_remaining_message_count();
      if(this.remainingConversations==0){
          this.$message.error("当前客服席位暂停服务，群您稍后再试。");
          return;
      }

      // 检查连接状态，如果断开则重连
      const state = getConnectionState(this.threadSlug);
      if (state === '已关闭' || state === '不存在') {
        console.log("连接已断开，正在重连...");
        await this.reconnectWebSocket();
      }

      // 重置错误状态
      this.hasError = false;
      this.errorMessage = '';

      // 验证输入
      if ((this.msg == null || this.msg.trim() === '') && this.uploadedImages.length === 0) {
        this.$message.error("请输入内容或上传图片");
        return;
      }
      if(this.uploadedImages.length>3){
        this.$message.error("最多只能上传3张图片");
        return;
      }

      if(this.msg.trim().length>1000){
        this.$message.error("最多只能输入1000个字符");
        return;
      }
      if(this.msg.trim().includes("系统提示词")){
        this.$message.error("请勿输入系统提示词");
        return;
      }
      // 检查是否已有错误或正在对话中
      if (this.hasError || this.isInConversation) {
            return;
      }
      this.isInConversation = true;
      this.isUploading = true;
      this.uploadProgress = 0;

      // 1. 先上传图片到OSS，获取URL
      let upload_error = false;
      const imageUrls = [];
      console.log("上传图片...", this.uploadedImages);
      for (const img of this.uploadedImages) {
        console.log("上传图片:", img.name);
        try {
          const url = await this.uploadImageToOSS(img.file);
          imageUrls.push(url);
        } catch (error) {
          upload_error=true;
          if (error.response && error.response.status === 429) {
          this.$message.error('上传图片数量超过今天的限额');


        }

          this.isInConversation = false;

          this.isUploading = false;
        }
      }
      this.isUploading = false;
      // 2. 构建最终消息内容（将图片URL整合到文本中）
      let finalMessage = this.msg.trim();
      console.log("imageUrls:", imageUrls)

      if (this.uploadedImages.length > 0) {
        // 将图片URL添加到消息内容中
        const imageReferences = imageUrls.map(url => `[图片](${url})`).join(' ');
        finalMessage = finalMessage ? `${finalMessage}\n${imageReferences}` : imageReferences;


      // 3. 添加到聊天历史（显示用）

      if (!upload_error) {
        this.chathistory.push({

          "id": this.chathistory.length + 1,
          "role": "user",
          "content": this.msg.trim(), // 使用包含图片URL的完整消息
          "images": this.uploadedImages.map(img => img.preview) // 存储预览图用于显示
        });

        // 4. 添加助手回复占位
        this.chathistory.push({
          "id": this.chathistory.length + 1,
          "role": "assistant",
          "content": ""
        });
      }
    }else {
      const currentMsg = this.msg.trim();
      console.log("发送消息：" + currentMsg);
      this.isInConversation = true;
      this.chathistory.push({ "id": this.chathistory.length + 1, "role": "user", "content": currentMsg });
      this.chathistory.push({ "id": this.chathistory.length + 1, "role": "assistant", "content": "" });
    }

      // 5. 构造请求对象（根据后端API调整）
      const requestData = {
        aiSeatId: this.aiSeatId,
        workspaceSlug: this.slug,
        message: finalMessage, // 包含图片URL的完整消息
        threadSlug: this.threadSlug,
        reset: false,
        mode: this.mode,
        // 根据后端支持情况决定是否添加images字段
        ...(imageUrls.length > 0 && { imageUrls: imageUrls })
      };

      console.log("发送消息:", finalMessage, "图片URL:", imageUrls);

      try {
        console.log("initWebSocket", requestData);
        // 6. 发送请求
        await sendStreamChatRequest(requestData);
      } catch (error) {
        console.error("发送消息失败:", error);
        this.$message.error("消息发送失败");
        // 可以考虑移除刚才添加的历史记录
        console.log("移除刚才添加的历史记录..",this.chathistory);
        this.chathistory.pop(); // 移除助手占位
        this.chathistory.pop(); // 移除用户消息
        console.log("移除完毕..",this.chathistory);
        this.isInConversation = false;
        this.isUploading = false;
        return;
      }

      // 7. 清空输入
      this.msg = "";
      this.clearAllImages();

      // 8. 保持焦点
      this.$nextTick(() => {
        const textarea = this.$el.querySelector('textarea');
        if (textarea) {
          textarea.focus();
        }
      });
    },

    stop() {
      // 1. 关闭WebSocket连接
      closeWebSocket(this.threadSlug);

      // 2. 更新UI状态
      this.isInConversation = false;
      this.isStopped = true;
      this.isReady = false;
      this.placeholderText = "对话已经停止...";

      // 3. 可选：添加停止提示到历史记录
      this.chathistory[this.chathistory.length - 1] = {
        id: this.chathistory.length + 1,
        role: "assistant",
        content: "已收到您的指令，对话已停止。您可以点击【开启新对话】重新开启对话。"
      };

  console.log(`对话已停止，线程: ${this.threadSlug}`);

  // 4. 触发事件
  this.$emit('stop-chat');
    },
    hasCompleteTable(content) {
    if (!content.includes('|')) return false;

    const lines = content.split('\n');

    // 检查是否有表头、分隔线和至少一行数据
    if (lines.length < 3) return false;

    // 检查分隔线特征（包含 - 或 :）
    const hasSeparator = lines.some(line =>
      line.includes('-') || line.includes(':')
    );

    // 检查是否有完整的数据行
    const hasDataRows = lines.filter(line =>
      line.includes('|') && !line.includes('-') && !line.includes(':')
    ).length >= 1;

    return hasSeparator && hasDataRows;
    },
    formatContent(content) {
      if (!content) return '';
      
      // 如果已经是 HTML 内容，直接返回
      if (content.includes('<img') || content.includes('<div')) {
        return content;
      }      
      console.log('=== 开始格式化内容 ===');
      console.log('原始内容:', content);
      
      // 特殊处理：如果包含系统结束消息，先提取并保护
      let systemEndMessage = null;
      if (content.includes('CONVERSATION_TIMEOUT')) {
        console.log('检测到系统结束消息');
        const systemMatch = content.match(/\(type:\s*['"]CONVERSATION_TIMEOUT['"][^)]*\)/);
        if (systemMatch) {
          systemEndMessage = systemMatch[0];
          content = content.replace(systemMatch[0], '').trim();
        }
      }
      
      let processed = content;
      
      // 处理顺序（确保系统消息不受影响）
      const processors = [
        'think',           // ← 新增：先过滤思维链
        'code', 
        'flowchart', 
        'table', 
        'list', 
        'heading', 
        'bold', 
        'link', 
        'emphasis', 
        'br'
      ];
      
      processors.forEach(processorName => {
        if (this.CONTENT_PROCESSORS[processorName]) {
          processed = this.CONTENT_PROCESSORS[processorName](processed);
        }
      });
      
      // 如果有系统消息，添加回去（不处理）
      if (systemEndMessage) {
        processed += `<div class="system-end-message">${systemEndMessage}</div>`;
      }
      
      console.log('=== 最终处理结果 ===', processed);
      return processed;
    },

    _highlightCode(lang, code) {
          try {
            // 确保代码中的换行符保留
            const result = hljs.highlight(code, {
              language: lang || 'plaintext'
            }).value;

            return result;
          } catch (e) {
            console.error('高亮失败:', e);
            return code; // 返回原始代码（保留换行）
          }
      },

    // 图片查看器相关方法
    openImageViewer(imageUrl, imageList = null, index = 0) {
      // 如果没有传入图片列表，尝试从当前消息中获取
      let imagesToShow = imageList;
      
      if (!imagesToShow) {
        // 尝试从当前选中的消息中获取图片
        const lastAssistantMsg = this.chathistory
          .filter(msg => msg.role === 'assistant')
          .pop();
        
        if (lastAssistantMsg) {
          const content = lastAssistantMsg.formatted || lastAssistantMsg.content;
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = content;
          const imgElements = tempDiv.querySelectorAll('img');
          imagesToShow = Array.from(imgElements)
            .map(img => img.src)
            .filter(src => src && src.trim());
        }
        
        // 如果还是没有，使用单张图片
        if (!imagesToShow || imagesToShow.length === 0) {
          imagesToShow = [imageUrl];
        }
      }
      
      // 确保当前图片在列表中
      let currentIndex = index;
      if (currentIndex >= imagesToShow.length) {
        currentIndex = 0;
      }
      
      this.imageViewer = {
        visible: true,
        currentImage: imagesToShow[currentIndex] || imageUrl,
        currentIndex: currentIndex,
        imageList: imagesToShow
      };
      
      document.body.style.overflow = 'hidden';
      this.addKeyboardEvents();
      
      console.log("打开图片查看器，图片列表:", imagesToShow);
    },

    closeImageViewer() {
      this.imageViewer.visible = false;
      document.body.style.overflow = '';
      this.removeKeyboardEvents();
    },

    showPrevImage() {
      if (this.imageViewer.imageList.length <= 1) return;
      const newIndex = (this.imageViewer.currentIndex - 1 + this.imageViewer.imageList.length) %
                      this.imageViewer.imageList.length;
      this.switchImage(newIndex);
    },

    showNextImage() {
      if (this.imageViewer.imageList.length <= 1) return;
      const newIndex = (this.imageViewer.currentIndex + 1) % this.imageViewer.imageList.length;
      this.switchImage(newIndex);
    },

    switchImage(index) {
      this.isImageLoading = true;
      this.imageViewer.currentIndex = index;
      this.imageViewer.currentImage = this.imageViewer.imageList[index];
    },

    getCurrentMessageImages() {
      return this.uploadedImages.map(img => img.preview);
    },

    getThumbnailUrl(imageUrl) {
      if (imageUrl.includes('oss.aliyuncs.com')) {
        return imageUrl + '?x-oss-process=image/resize,w_100';
      }
      return imageUrl;
    },

    onImageLoad() {
      this.isImageLoading = false;
    },

    onImageError() {
      this.isImageLoading = false;
      this.$message.error('图片加载失败');
    },

    openPreviewImage(previewUrl, index) {
      this.imageViewer = {
        visible: true,
        currentImage: previewUrl,
        currentIndex: index,
        imageList: this.uploadedImages.map(img => img.preview)
      };
      document.body.style.overflow = 'hidden';
    },

    addKeyboardEvents() {
      this.removeKeyboardEvents();
      this.keyboardHandler = (e) => {
        // 如果AI图片查看器打开，处理AI的
        if (this.aiImageViewer.visible) {
          if (e.key === 'Escape') {
            e.preventDefault();
            this.closeAiImageViewer();
          }
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.showAiPrevImage();
          }
          if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.showAiNextImage();
          }
        }
        // 如果普通图片查看器打开，处理普通的
        else if (this.imageViewer.visible) {
          if (e.key === 'Escape') {
            e.preventDefault();
            this.closeImageViewer();
          }
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.showPrevImage();
          }
          if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.showNextImage();
          }
        }
      };
      window.addEventListener('keydown', this.keyboardHandler);
    },

    removeKeyboardEvents() {
      if (this.keyboardHandler) {
        window.removeEventListener('keydown', this.keyboardHandler);
        this.keyboardHandler = null;
      }
    },

    setupCopyButtons() {
      this.$nextTick(() => {
        const container = this.$refs.historybox;
        if (!container) return;

        container.querySelectorAll('.copy-btn').forEach(btn => {
          btn.onclick = () => {
            const codeId = btn.getAttribute('data-code-id');
            const codeBlock = document.getElementById(codeId);
            if (codeBlock) {
              navigator.clipboard.writeText(codeBlock.textContent)
                .then(() => {
                  const textSpan = btn.querySelector('.copy-text');
                  if (textSpan) textSpan.textContent = '已复制';
                  setTimeout(() => {
                    if (textSpan) textSpan.textContent = '复制';
                  }, 2000);
                });
            }
          };
        });
      });
    },

    highlightAllCodeBlocks() {
      this.$nextTick(() => {
        document.querySelectorAll('pre code').forEach((block) => {
          if (!block.classList.contains('hljs')) {
            hljs.highlightBlock(block);
          }
        });
        this.setupCopyButtons();
      });
    },
    processFlowchartDirectly(content) {
      console.log('=== 直接处理流程图 ===');
      console.log('输入内容:', content);
      
      // 匹配行格式流程图
      const pattern = /【([^】]+)】\s*([^→]+(?:\s*→\s*[^→]+)+)/g;
      
      return content.replace(pattern, (match, title, stepsStr) => {
        console.log('匹配到流程图:', match);
        console.log('标题:', title);
        console.log('步骤字符串:', stepsStr);
        
        // 分割步骤
        const steps = stepsStr.split('→').map(step => step.trim()).filter(step => step);
        console.log('步骤数组:', steps);
        
        // 生成HTML
        return `
          <div class="simple-flowchart-container">
            <div class="flowchart-title">${title}</div>
            <div class="flowchart-steps">
              ${steps.map((step, index) => `
                <div class="flow-step">
                  <div class="step-number">${index + 1}</div>
                  <div class="step-content">${step}</div>
                  ${index < steps.length - 1 ? '<div class="step-arrow">→</div>' : ''}
                </div>
              `).join('')}
            </div>
          </div>
        `;
      });
    },
  // 窗口状态切换方法
  toggleWindowState() {
    // 循环切换状态
    this.currentStateIndex = (this.currentStateIndex + 1) % this.windowStates.length;
    
    // 根据新状态调整窗口
    this.applyWindowState();
  },
  
  // 应用窗口状态
applyWindowState() {
  const chatWidget = this.$el;
  
  // 先重置所有状态类
  chatWidget.classList.remove('half-screen-mode', 'fullscreen-mode', 'minimized-mode');
  
  // 根据当前状态添加对应的类
  switch (this.currentState) {
    case 'half-screen':
      this.applyHalfScreen();
      chatWidget.classList.add('half-screen-mode');
      break;
      
    case 'fullscreen':
      this.applyFullScreen();
      chatWidget.classList.add('fullscreen-mode');
      break;
      
    default:
      this.resetToDefault();
      break;
  }
  
  // 确保窗口不被最小化
  this.isMinimized = false;
  
  // 强制重新计算样式
  this.$forceUpdate();
},
  
  // 重置为默认状态
  resetToDefault() {
    const chatWidget = this.$el;
    
    // 移除所有样式类
    chatWidget.classList.remove('half-screen-mode', 'fullscreen-mode');
    
    // 应用默认样式
    Object.assign(chatWidget.style, {
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      width: '380px',
      height: '600px',
      maxWidth: 'none',
      maxHeight: 'none',
      top: 'auto',
      left: 'auto',
      borderRadius: '12px',
      transition: 'all 0.3s ease'
    });
  },
  
  // 应用半屏模式
  applyHalfScreen() {
    const chatWidget = this.$el;
    //const viewportWidth = window.innerWidth;
    //const viewportHeight = window.innerHeight;
    
    chatWidget.classList.remove('fullscreen-mode');
    chatWidget.classList.add('half-screen-mode');
    
    Object.assign(chatWidget.style, {
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '50vw',
      height: '70vh',
      maxWidth: '800px',
      maxHeight: '90vh',
      borderRadius: '12px',
      bottom: 'auto',
      right: 'auto'
    });
  },
  
  // 应用全屏模式
  applyFullScreen() {
    const chatWidget = this.$el;
    
    chatWidget.classList.remove('half-screen-mode');
    chatWidget.classList.add('fullscreen-mode');
    
    Object.assign(chatWidget.style, {
      position: 'fixed',
      top: '0',
      left: '0',
      width: '100vw',
      height: '100vh',
      maxWidth: 'none',
      maxHeight: 'none',
      borderRadius: '0',
      transform: 'none',
      bottom: 'auto',
      right: 'auto',
      zIndex: '10000' // 确保在最上层
    });
  },
  
  handleResize() {
    // 延迟执行，避免频繁重绘
    clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(() => {
      if (this.currentState === 'half-screen') {
        this.applyHalfScreen();
      } else if (this.currentState === 'fullscreen') {
        this.applyFullScreen();
      }
    }, 100);
  },
 // 显示用户评价
    showUserRating(conversationEndData) {
      console.log('显示用户评价:', conversationEndData);
      
      this.ratingConversationInfo = {
        aiSeatId: this.aiSeatId,
        threadSlug: conversationEndData.threadSlug,
        workspaceSlug: conversationEndData.workspaceSlug,
        title: conversationEndData.title || '请您对服务质量进行评价',
        reply: conversationEndData.reply || '',
        customerIntent: conversationEndData.customerIntent || '',
        sentiment: conversationEndData.sentiment || '中性'
      };
      
      // 延迟显示评价弹窗，让用户有时间阅读结束消息
      setTimeout(() => {
        this.showRating = true;
      }, 1500);
    },
 // 显示用户评价
    showHumanServiceDialog() {
      console.log('显示用户评价:');
      
      this.ratingConversationInfo = {
        aiSeatId: this.aiSeatId,
        threadSlug: this.threadSlug,
        workspaceSlug: this.workspaceSlug,  
      };
      
      // 延迟显示评价弹窗，让用户有时间阅读结束消息
      setTimeout(() => {
        this.showHumanService = true;
      }, 1500);
    },    

    // 获取当前对话ID（需要根据你的数据结构调整）
    getCurrentConversationId() {
      // 这里需要根据你的实际数据结构获取对话ID
      // 示例：从会话历史或状态中获取
      return Date.now(); // 临时方案
    },
    // 找人工提交后的处理
    onHumanServiceSubmitted(humanServiceData){
      console.log('收到找人工信息:', humanServiceData);
      this.$message.success('提交成功，感谢您的反馈！收到消息，我们会尽快处理或安排专人与您联系');
    },
    // 评价提交后的处理
    onFeedbackSubmitted(feedbackData) {
      console.log('收到用户评价:', feedbackData);
      this.$message.success('感谢您的评价！');
    },
    // 跳过评价的处理
    onFeedbackSkipped() {
      console.log('用户跳过了评价');
    },
   // 关闭评价弹窗
    closeRating() {
      this.showRating = false;
      this.ratingConversationInfo = null;
    },  
    HandleShowRating(){
      this.showRating = true;
      this.ratingConversationInfo = {
        title:'',
        threadSlug: this.threadSlug,
        workspaceSlug: this.workspaceSlug
      };
    },
    HandleShowHumanService(){
      this.showHumanService = true;
      this.ratingConversationInfo = {
        title:'',
        threadSlug: this.threadSlug,
        workspaceSlug: this.workspaceSlug
      };
    },  
    //关闭找人工弹框
    closeHumanService(){
        this.showHumanService = false;
    },
    // 下面是查看AI回复图片的代码
    /**
     * 从AI回复内容中提取图片URL
     */
    extractImagesFromContent(content) {
      if (!content) return [];
      
      const images = [];
      
      try {
        // 方法1: 从HTML标签中提取
        const parser = new DOMParser();
        const doc = parser.parseFromString(content, 'text/html');
        const imgElements = doc.querySelectorAll('img');
        
        imgElements.forEach(img => {
          if (img.src && img.src.trim()) {
            images.push(img.src.trim());
          }
        });
        
        // 方法2: 正则匹配（备用）
        if (images.length === 0) {
          const imgRegex = /src=["']([^"']+\.(?:jpg|jpeg|png|gif|webp|bmp))["']/gi;
          let match;
          while ((match = imgRegex.exec(content)) !== null) {
            if (match[1]) {
              images.push(match[1]);
            }
          }
        }
        
        console.log("从内容中提取到的图片:", images);
      } catch (error) {
        console.error("提取图片失败:", error);
      }
      
      return images;
    },
    
    /**
     * 打开AI图片查看器
     */
    openAiImageViewer(imgUrl, content) {
      console.log("打开AI图片查看器:", imgUrl);
      
      // 从内容中提取所有图片
      const imageList = this.extractImagesFromContent(content);
      
      if (imageList.length === 0) {
        console.warn("未找到图片");
        return;
      }
      
      // 找到当前图片的索引
      let currentIndex = 0;
      if (imgUrl) {
        currentIndex = imageList.findIndex(img => img === imgUrl);
        if (currentIndex === -1) currentIndex = 0;
      }
      
      this.aiImageViewer = {
        visible: true,
        currentImage: imageList[currentIndex],
        currentIndex: currentIndex,
        imageList: imageList
      };
      
      document.body.style.overflow = 'hidden';
      this.addKeyboardEvents();
    },
    
    /**
     * 关闭AI图片查看器
     */
    closeAiImageViewer() {
      this.aiImageViewer.visible = false;
      document.body.style.overflow = '';
      this.removeKeyboardEvents();
    },
    
    /**
     * 切换到上一张图片
     */
    showAiPrevImage() {
      if (this.aiImageViewer.imageList.length <= 1) return;
      const newIndex = (this.aiImageViewer.currentIndex - 1 + this.aiImageViewer.imageList.length) %
                      this.aiImageViewer.imageList.length;
      this.switchAiImage(newIndex);
    },
    
    /**
     * 切换到下一张图片
     */
    showAiNextImage() {
      if (this.aiImageViewer.imageList.length <= 1) return;
      const newIndex = (this.aiImageViewer.currentIndex + 1) % this.aiImageViewer.imageList.length;
      this.switchAiImage(newIndex);
    },
    
    /**
     * 切换指定索引的图片
     */
    switchAiImage(index) {
      this.isImageLoading = true;
      this.aiImageViewer.currentIndex = index;
      this.aiImageViewer.currentImage = this.aiImageViewer.imageList[index];
    },

    /**
       * 处理AI内容，为图片添加类名
       */
      processAiContent(item) {
        // 如果已经有 formatted 字段，直接使用
        if (item.formatted) {
          return item.formatted;
        }
        
        // 否则格式化原始内容
        let content = this.formatContent(item.content || '');
        
        if (!content) return content;
        
        // 为所有图片添加ai-image类
        content = content.replace(/<img([^>]*)>/gi, (match, attributes) => {
          // 检查是否已经有class属性
          if (attributes.includes('class=')) {
            return match.replace(/class=["']([^"']*)["']/, (classMatch, classValue) => {
              return `class="${classValue} ai-image"`;
            });
          } else {
            return `<img class="ai-image"${attributes}>`;
          }
        });
        
        return content;
      },     

      handleAiContentClick(event, item) {
        const target = event.target;
        
        // 检查点击的是否是图片或图片的父元素
        let imgElement = target;
        if (target.tagName !== 'IMG') {
          imgElement = target.closest('img');
        }
        
        if (imgElement && imgElement.tagName === 'IMG') {
          const imgUrl = imgElement.src;
          console.log("点击了AI图片:", imgUrl);
          
          // 从当前消息中获取所有图片
          const content = item.formatted || item.content;
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = content;
          const imgElements = tempDiv.querySelectorAll('img');
          
          const imageList = Array.from(imgElements)
            .map(img => img.src)
            .filter(src => src && src.trim());
          
          console.log("提取到的图片列表:", imageList);
          
          // 如果提取失败，至少添加点击的这张
          if (imageList.length === 0 && imgUrl) {
            imageList.push(imgUrl);
          }
          
          let currentIndex = imageList.findIndex(img => img === imgUrl);
          
          // 如果没有完全匹配，尝试基本URL匹配（去除查询参数）
          if (currentIndex === -1) {
            const baseUrl = imgUrl.split('?')[0];
            currentIndex = imageList.findIndex(img => {
              const imgBaseUrl = img.split('?')[0];
              return imgBaseUrl === baseUrl;
            });
          }
          
          if (imageList.length > 0) {
            console.log("打开图片查看器，图片数量:", imageList.length, "当前索引:", currentIndex);
            this.openImageViewer(
              currentIndex >= 0 ? imageList[currentIndex] : imageList[0],
              imageList,
              currentIndex >= 0 ? currentIndex : 0
            );
          } else {
            console.warn("没有找到可显示的图片");
          }
        }
      },
      /**
       * 强制设置图片光标样式
       */
      forceSetImageCursor() {
        // 为AI消息中的图片设置样式
        const aiContainers = document.querySelectorAll('.ai-message-content, .message-container');
        
        aiContainers.forEach(container => {
          const images = container.querySelectorAll('img');
          images.forEach(img => {
            // 内联样式最高优先级
            img.style.cursor = 'zoom-in';
            img.style.maxWidth = '100%';
            img.style.maxHeight = '300px';
            img.style.height = 'auto';
            img.style.borderRadius = '6px';
            img.style.margin = '4px 0';
            img.style.objectFit = 'contain';
            img.style.transition = 'all 0.2s ease';
            
            // 添加悬停效果
            img.onmouseenter = () => {
              img.style.transform = 'scale(1.02)';
              img.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.2)';
            };
            
            img.onmouseleave = () => {
              img.style.transform = 'scale(1)';
              img.style.boxShadow = 'none';
            };
            
            // 确保点击事件
            if (!img.onclick) {
              img.onclick = (e) => {
                e.stopPropagation();
                
                // 找到对应的消息item
                const parentMessage = img.closest('.ai-message-content, .message-container');
                if (parentMessage) {
                  const allImages = parentMessage.querySelectorAll('img');
                  const imageList = Array.from(allImages)
                    .map(i => i.src)
                    .filter(src => src && src.trim());
                  const currentIndex = imageList.indexOf(img.src);
                  
                  if (imageList.length > 0) {
                    this.openImageViewer(
                      img.src,
                      imageList,
                      currentIndex >= 0 ? currentIndex : 0
                    );
                  } else {
                    this.openImageViewer(img.src, [img.src], 0);
                  }
                } else {
                  this.openImageViewer(img.src, [img.src], 0);
                }
              };
            }
          });
        });
      },      
  }
}
</script>

<style scoped>
/* ============================================================
   ChatWidget.vue - 完整样式
   说明：所有样式都使用 [data-fixed-root="true"] 选择器隔离
   ============================================================ */

/* ========== 1. 聊天窗口基础样式 ========== */
.chat-widget[data-fixed-root="true"] {
  position: fixed !important;
  bottom: 20px !important;
  right: 20px !important;
  top: auto !important;
  left: auto !important;
  width: 380px !important;
  height: 600px !important;
  max-width: 90vw !important;
  max-height: 80vh !important;
  background: #ffffff !important;
  border-radius: 12px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2) !important;
  z-index: 21000 !important;
  display: flex !important;
  flex-direction: column !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
  overflow: hidden !important;
  transform: none !important;
  margin: 0 !important;
  padding: 0 !important;
  contain: none !important;
  will-change: auto !important;
  filter: none !important;
  backdrop-filter: none !important;
  isolation: isolate !important;
}

/* ========== 2. 状态样式 ========== */

/* 2.1 隐藏状态 */
.chat-widget[data-fixed-root="true"].hidden {
  display: none !important;
}

/* 2.2 最小化状态 */
.chat-widget[data-fixed-root="true"].minimized {
  position: fixed !important;
  bottom: 20px !important;
  right: 20px !important;
  top: auto !important;
  left: auto !important;
  width: 200px !important;
  height: 56px !important;
  border-radius: 28px !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15) !important;
  overflow: hidden !important;
}

.chat-widget[data-fixed-root="true"].minimized .chat-content,
.chat-widget[data-fixed-root="true"].minimized .header-banner {
  display: none !important;
}

.chat-widget[data-fixed-root="true"].minimized .chat-header {
  min-height: 56px !important;
  height: 56px !important;
  padding: 0 16px !important;
  border-radius: 28px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.chat-widget[data-fixed-root="true"].minimized .header-top-row {
  height: 56px !important;
  padding: 0 !important;
  margin: 0 !important;
  align-items: center !important;
}

.chat-widget[data-fixed-root="true"].minimized .header-right {
  display: none !important;
}

.chat-widget[data-fixed-root="true"].minimized .header-left {
  margin: 0 !important;
  justify-content: center !important;
  width: 100% !important;
}

.chat-widget[data-fixed-root="true"].minimized .header-title {
  font-size: 13px !important;
  max-width: 100% !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  text-align: center !important;
}

.chat-widget[data-fixed-root="true"].minimized .header-avatar {
  width: 28px !important;
  height: 28px !important;
}

/* 2.3 半屏模式 */
.chat-widget[data-fixed-root="true"].half-screen-mode {
  position: fixed !important;
  top: 50% !important;
  left: 50% !important;
  right: auto !important;
  bottom: auto !important;
  transform: translate(-50%, -50%) !important;
  width: 50vw !important;
  height: 70vh !important;
  max-width: 800px !important;
  max-height: 90vh !important;
  border-radius: 16px !important;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3) !important;
  z-index: 100000 !important;
}

.chat-widget[data-fixed-root="true"].half-screen-mode .header-right {
  margin-left: 0 !important;
  margin-top: 0 !important;
}

.chat-widget[data-fixed-root="true"].half-screen-mode .chat-header {
  min-height: 50px !important;
  height: auto !important;
  padding: 6px 14px !important;
}

.chat-widget[data-fixed-root="true"].half-screen-mode .header-top-row {
  height: 38px !important;
  padding: 0 !important;
  margin: 0 !important;
  min-height: 38px !important;
}

.chat-widget[data-fixed-root="true"].half-screen-mode .header-banner {
  height: 45px !important;
}

.chat-widget[data-fixed-root="true"].half-screen-mode .chat-content {
  height: calc(100% - 105px) !important;
}

/* 2.4 全屏模式 */
.chat-widget[data-fixed-root="true"].fullscreen-mode {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  max-width: none !important;
  max-height: none !important;
  border-radius: 0 !important;
  transform: none !important;
  z-index: 999999 !important;
  overflow: hidden !important;
}

.chat-widget[data-fixed-root="true"].fullscreen-mode .chat-header {
  padding: 8px 16px !important;
  border-radius: 0 !important;
  min-height: 56px !important;
  flex-shrink: 0 !important;
  overflow: visible !important;  /* 关键：允许子元素溢出 */
}


.chat-widget[data-fixed-root="true"].fullscreen-mode .header-top-row {
  height: 48px !important;
  padding: 0 !important;
  margin: 0 !important;
  min-height: 48px !important;
  overflow: visible !important;  /* 关键：允许子元素溢出 */
}

.chat-widget[data-fixed-root="true"].fullscreen-mode .header-left {
  margin-top: 0 !important;
  overflow: visible !important;
}

/* 全屏模式右侧按钮 - 重置 margin-left */
.chat-widget[data-fixed-root="true"].fullscreen-mode .header-right {
  margin-left: 0 !important;
  margin-top: 0 !important;
  margin-right: 4px !important;  /* 增加右侧边距 */
  gap: 8px !important;
  flex-shrink: 0 !important;
  align-items: center !important;
  height: 100% !important;
  overflow: visible !important;  /* 关键：允许子元素溢出 */
  padding-right: 4px !important;
}

chat-widget[data-fixed-root="true"].fullscreen-mode .header-title {
  font-size: 18px !important;
  max-width: 300px !important;
}

.chat-widget[data-fixed-root="true"].fullscreen-mode .header-btn {
  width: 40px !important;
  height: 40px !important;
  font-size: 20px !important;
  border-radius: 8px !important;
  flex-shrink: 0 !important;
  min-width: 40px !important;
}

.chat-widget[data-fixed-root="true"].fullscreen-mode .close-btn {
  width: 40px !important;
  height: 40px !important;
  font-size: 32px !important;
  font-weight: 300 !important;
  background: rgba(255, 255, 255, 0.15) !important;
  border: none !important;
  color: white !important;
  border-radius: 8px !important;
  cursor: pointer !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 !important;
  margin: 0 !important;
  margin-right: 0 !important;
  position: relative !important;
  top: 0 !important;
  right: 0 !important;
  transform: none !important;
  z-index: 10 !important;
  flex-shrink: 0 !important;
  min-width: 40px !important;
}

.chat-widget[data-fixed-root="true"].fullscreen-mode .close-btn:hover {
  background: rgba(255, 0, 0, 0.4) !important;
  color: #ff6b6b !important;
  transform: scale(1.05) !important;
}

.chat-widget[data-fixed-root="true"].fullscreen-mode .header-banner {
  height: 80px !important;
  margin: 4px 0 !important;
}

.chat-widget[data-fixed-root="true"].fullscreen-mode .chat-content {
  height: calc(100% - 150px) !important;
}

.chat-widget[data-fixed-root="true"].fullscreen-mode .message-content-wrapper {
  max-width: 85% !important;
}

.chat-widget[data-fixed-root="true"].fullscreen-mode .history-container {
  padding: 16px !important;
}

.chat-widget[data-fixed-root="true"].fullscreen-mode .input-container {
  padding: 12px 16px !important;
}

.chat-widget[data-fixed-root="true"].fullscreen-mode .input-container textarea {
  min-height: 80px !important;
  font-size: 16px !important;
}

.chat-widget[data-fixed-root="true"].fullscreen-mode .button-bar .btn {
  padding: 8px 16px !important;
  font-size: 14px !important;
}

/* ========== 3. 头部样式 ========== */
.chat-widget[data-fixed-root="true"] .chat-header {
  display: flex !important;
  flex-direction: column !important;
  padding: 8px 12px !important;
  background: #057FDB !important;
  color: white !important;
  border-radius: 12px 12px 0 0 !important;
  cursor: pointer !important;
  min-height: auto !important;
  height: auto !important;
  z-index: 1 !important;
  flex-shrink: 0 !important;
  user-select: none !important;
}

.chat-widget[data-fixed-root="true"] .header-top-row {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  width: 100% !important;
  margin-bottom: 4px !important;
  flex-shrink: 0 !important;
  position: relative !important;
  z-index: 2 !important;
  padding: 2px 0 !important;
  min-height: 36px !important;
}

.chat-widget[data-fixed-root="true"] .header-left {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  flex-shrink: 0 !important;
  min-width: 0 !important;
  margin-top: 0 !important;
}

.chat-widget[data-fixed-root="true"] .header-right {
  display: flex !important;
  gap: 2px !important;
  flex-shrink: 0 !important;
  align-items: center !important;
  margin-top: 0 !important;
  margin-right: 0 !important;
  padding-right: 0 !important;
  height: 100% !important;
  margin-left: 0 !important;
}

.chat-widget[data-fixed-root="true"] .header-avatar {
  width: 28px !important;
  height: 28px !important;
  border-radius: 50% !important;
  object-fit: cover !important;
  flex-shrink: 0 !important;
}

.chat-widget[data-fixed-root="true"] .header-title {
  font-weight: 600 !important;
  font-size: 14px !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  color: white !important;
  display: inline-block !important;
  max-width: 120px !important;
}

.chat-widget[data-fixed-root="true"] .header-btn {
  background: rgba(255, 255, 255, 0.2) !important;
  border: none !important;
  color: white !important;
  width: 28px !important;
  height: 28px !important;
  border-radius: 4px !important;
  cursor: pointer !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 16px !important;
  transition: all 0.2s ease !important;
  flex-shrink: 0 !important;
  padding: 0 !important;
  line-height: 1 !important;
  position: relative !important;
  top: 0 !important;
  transform: none !important;
}

.chat-widget[data-fixed-root="true"] .header-btn:hover {
  background: rgba(255, 255, 255, 0.3) !important;
  transform: scale(1.1) !important;
}

.chat-widget[data-fixed-root="true"] .close-btn {
  font-size: 20px !important;
  font-weight: 300 !important;
  line-height: 1 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 !important;
  margin: 0 !important;
  width: 28px !important;
  height: 28px !important;
  background: rgba(255, 255, 255, 0.2) !important;
  border: none !important;
  color: white !important;
  border-radius: 4px !important;
  cursor: pointer !important;
  position: relative !important;
  top: 0 !important;
  right: 0 !important;
  transform: none !important;
  z-index: 10 !important;
}

.chat-widget[data-fixed-root="true"] .close-btn:hover {
  background: rgba(255, 0, 0, 0.3) !important;
  color: #ff6b6b !important;
}

.chat-widget[data-fixed-root="true"] .header-banner {
  width: 100% !important;
  height: 100px !important;
  border-radius: 6px !important;
  overflow: hidden !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2) !important;
  transition: all 0.3s ease !important;
  flex-shrink: 0 !important;
  margin-top: 2px !important;
  margin-bottom: 0 !important;
}

.chat-widget[data-fixed-root="true"] .header-banner:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3) !important;
}

.chat-widget[data-fixed-root="true"] .banner-image {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
  border-radius: 6px !important;
}

/* ========== 4. 内容区域样式 ========== */
.chat-widget[data-fixed-root="true"] .chat-content {
  flex: 1 !important;
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
  min-height: 0 !important;
}

.chat-widget[data-fixed-root="true"] .history-container {
  flex: 1 !important;
  overflow-y: auto !important;
  padding: 8px !important;
  background-color: #f5f5f5 !important;
}

/* ========== 5. 消息列表样式 ========== */
.chat-widget[data-fixed-root="true"] .message-list {
  list-style: none !important;
  padding: 0 !important;
  margin: 0 !important;
}

.chat-widget[data-fixed-root="true"] .message-item {
  display: flex !important;
  margin-bottom: 8px !important;
  align-items: flex-start !important;
}

.chat-widget[data-fixed-root="true"] .message-item.user {
  flex-direction: row-reverse !important;
}

.chat-widget[data-fixed-root="true"] .avatar {
  width: 32px !important;
  height: 32px !important;
  border-radius: 50% !important;
  object-fit: cover !important;
  flex-shrink: 0 !important;
}

.chat-widget[data-fixed-root="true"] .assistant-avatar {
  margin-right: 8px !important;
}

.chat-widget[data-fixed-root="true"] .user-avatar {
  margin-left: 8px !important;
}

.chat-widget[data-fixed-root="true"] .loading-indicator {
  width: 20px !important;
  height: 20px !important;
  margin-right: 12px !important;
}

.chat-widget[data-fixed-root="true"] .message-content-wrapper {
  max-width: 70% !important;
}

.chat-widget[data-fixed-root="true"] .message-container {
  background-color: #42b983 !important;
  color: white !important;
  padding: 8px 12px !important;
  border-radius: 12px !important;
  border-bottom-left-radius: 4px !important;
  max-width: 100% !important;
  line-height: 1.4 !important;
  font-size: 14px !important;
}

.chat-widget[data-fixed-root="true"] .message-item.user .message-content-wrapper {
  display: flex !important;
  justify-content: flex-end !important;
}

.chat-widget[data-fixed-root="true"] .message-item.user .message-container {
  background-color: deepskyblue !important;
  border-bottom-right-radius: 4px !important;
  border-bottom-left-radius: 12px !important;
}

.chat-widget[data-fixed-root="true"] .user-message {
  background-color: deepskyblue !important;
  color: white !important;
  padding: 8px 12px !important;
  border-radius: 12px !important;
  border-bottom-right-radius: 4px !important;
  display: inline-block !important;
  max-width: 100% !important;
  line-height: 1.4 !important;
  font-size: 14px !important;
}

.chat-widget[data-fixed-root="true"] .message-images {
  display: flex !important;
  flex-wrap: wrap !important;
  gap: 4px !important;
  margin-top: 4px !important;
}

.chat-widget[data-fixed-root="true"] .message-image {
  max-width: 120px !important;
  max-height: 120px !important;
  border-radius: 4px !important;
  overflow: hidden !important;
}

.chat-widget[data-fixed-root="true"] .message-image img {
  width: 100% !important;
  height: auto !important;
  object-fit: contain !important;
}

.chat-widget[data-fixed-root="true"] .clickable-image {
  cursor: pointer !important;
  transition: transform 0.2s !important;
}

.chat-widget[data-fixed-root="true"] .clickable-image:hover {
  transform: scale(1.05) !important;
}

/* 消息中的图片点击效果 */
.chat-widget[data-fixed-root="true"] .message-container img,
.chat-widget[data-fixed-root="true"] .user-message img,
.chat-widget[data-fixed-root="true"] .ai-message-content img {
  cursor: zoom-in !important;
  transition: all 0.2s ease !important;
  max-width: 100% !important;
  height: auto !important;
}

.chat-widget[data-fixed-root="true"] .message-container img:hover,
.chat-widget[data-fixed-root="true"] .user-message img:hover,
.chat-widget[data-fixed-root="true"] .ai-message-content img:hover {
  transform: scale(1.02) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
}

.chat-widget[data-fixed-root="true"] .ai-image {
  cursor: zoom-in !important;
  max-width: 100% !important;
  height: auto !important;
  border-radius: 6px !important;
  margin: 4px 0 !important;
  transition: all 0.2s ease !important;
}

.chat-widget[data-fixed-root="true"] .ai-image:hover {
  transform: scale(1.02) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
}

/* ========== 6. 输入区域样式 ========== */
.chat-widget[data-fixed-root="true"] .input-container {
  padding: 8px !important;
  background-color: white !important;
  border-top: 1px solid #e1e4e8 !important;
  flex-shrink: 0 !important;
}

.chat-widget[data-fixed-root="true"] .input-container textarea {
  width: 100% !important;
  min-height: 60px !important;
  padding: 8px !important;
  border: 1px solid #e1e4e8 !important;
  border-radius: 8px !important;
  resize: vertical !important;
  font-size: 14px !important;
  font-family: inherit !important;
  box-sizing: border-box !important;
}

.chat-widget[data-fixed-root="true"] .input-container textarea:focus {
  outline: none !important;
  border-color: #057FDB !important;
  box-shadow: 0 0 0 2px rgba(5, 127, 219, 0.1) !important;
}

.chat-widget[data-fixed-root="true"] .button-bar {
  display: flex !important;
  justify-content: flex-end !important;
  gap: 6px !important;
  margin-top: 8px !important;
}

.chat-widget[data-fixed-root="true"] .btn {
  padding: 4px 8px !important;
  border: none !important;
  border-radius: 4px !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
  display: flex !important;
  align-items: center !important;
  gap: 4px !important;
}

.chat-widget[data-fixed-root="true"] .btn-primary {
  background-color: #057FDB !important;
  color: white !important;
}

.chat-widget[data-fixed-root="true"] .btn-primary:hover {
  background-color: #0460a9 !important;
}

.chat-widget[data-fixed-root="true"] .btn-secondary {
  background-color: transparent !important;
  color: #057FDB !important;
  border: 1px solid #057FDB !important;
}

.chat-widget[data-fixed-root="true"] .btn-secondary:hover {
  background-color: rgba(5, 127, 219, 0.1) !important;
}

.chat-widget[data-fixed-root="true"] .btn-accent {
  background-color: #ff007f !important;
  color: white !important;
}

.chat-widget[data-fixed-root="true"] .btn-accent:hover {
  background-color: #d9006c !important;
}

/* ========== 7. 图片上传区域 ========== */
.chat-widget[data-fixed-root="true"] .image-upload-container {
  margin-top: 0.5rem !important;
  padding: 0.5rem !important;
  border: 1px dashed #e1e4e8 !important;
  border-radius: 8px !important;
}

.chat-widget[data-fixed-root="true"] .upload-label {
  display: inline-flex !important;
  align-items: center !important;
  gap: 0.5rem !important;
  padding: 0.5rem 1rem !important;
  background-color: #f5f5f5 !important;
  border-radius: 4px !important;
  cursor: pointer !important;
  transition: background-color 0.2s !important;
}

.chat-widget[data-fixed-root="true"] .upload-label:hover {
  background-color: rgba(5, 127, 219, 0.1) !important;
}

.chat-widget[data-fixed-root="true"] .image-previews {
  display: flex !important;
  flex-wrap: wrap !important;
  gap: 0.5rem !important;
  margin-top: 0.5rem !important;
}

.chat-widget[data-fixed-root="true"] .image-preview {
  position: relative !important;
  width: 80px !important;
  height: 80px !important;
  border-radius: 4px !important;
  overflow: hidden !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
}

.chat-widget[data-fixed-root="true"] .image-preview img {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
}

.chat-widget[data-fixed-root="true"] .remove-image {
  position: absolute !important;
  top: 2px !important;
  right: 2px !important;
  width: 20px !important;
  height: 20px !important;
  border: none !important;
  border-radius: 50% !important;
  background-color: rgba(255, 255, 255, 0.8) !important;
  color: #ff4d4f !important;
  font-weight: bold !important;
  cursor: pointer !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 !important;
  font-size: 14px !important;
}

/* ========== 8. 图片查看器模态框 ========== */
.chat-widget[data-fixed-root="true"] .image-viewer-modal {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  background-color: rgba(0, 0, 0, 0.95) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  z-index: 999999 !important;
  animation: fadeIn 0.3s ease !important;
}

.chat-widget[data-fixed-root="true"] .image-viewer-content {
  position: relative !important;
  width: 90vw !important;
  height: 90vh !important;
  max-width: 1200px !important;
  max-height: 900px !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  background: rgba(20, 20, 20, 0.95) !important;
  border-radius: 12px !important;
  padding: 20px !important;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5) !important;
}

.chat-widget[data-fixed-root="true"] .image-viewer-modal .close-btn {
  position: absolute !important;
  top: 15px !important;
  right: 15px !important;
  background: rgba(255, 255, 255, 0.1) !important;
  border: none !important;
  color: white !important;
  width: 44px !important;
  height: 44px !important;
  border-radius: 50% !important;
  cursor: pointer !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  z-index: 10 !important;
  font-size: 24px !important;
  transition: all 0.3s !important;
}

.chat-widget[data-fixed-root="true"] .image-viewer-modal .close-btn:hover {
  background: rgba(255, 0, 0, 0.3) !important;
  transform: scale(1.1) !important;
}

.chat-widget[data-fixed-root="true"] .image-viewer-modal .nav-btn {
  position: absolute !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  background: rgba(255, 255, 255, 0.2) !important;
  border: none !important;
  color: white !important;
  width: 50px !important;
  height: 50px !important;
  border-radius: 50% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  cursor: pointer !important;
  z-index: 10 !important;
  transition: all 0.3s !important;
}

.chat-widget[data-fixed-root="true"] .image-viewer-modal .nav-btn:hover {
  background: rgba(255, 255, 255, 0.3) !important;
  transform: translateY(-50%) scale(1.1) !important;
}

.chat-widget[data-fixed-root="true"] .image-viewer-modal .prev-btn {
  left: 20px !important;
}

.chat-widget[data-fixed-root="true"] .image-viewer-modal .next-btn {
  right: 20px !important;
}

.chat-widget[data-fixed-root="true"] .image-viewer-modal .image-container {
  position: relative !important;
  width: 100% !important;
  height: calc(100% - 120px) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  overflow: hidden !important;
  margin: 20px 0 !important;
}

.chat-widget[data-fixed-root="true"] .image-viewer-modal .image-container img {
  max-width: 100% !important;
  max-height: 100% !important;
  object-fit: contain !important;
  border-radius: 8px !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5) !important;
}

.chat-widget[data-fixed-root="true"] .image-viewer-modal .spinner {
  width: 40px !important;
  height: 40px !important;
  border: 3px solid rgba(255, 255, 255, 0.3) !important;
  border-top: 3px solid white !important;
  border-radius: 50% !important;
  animation: spin 1s linear infinite !important;
}

.chat-widget[data-fixed-root="true"] .image-viewer-modal .thumbnail-nav {
  display: flex !important;
  gap: 10px !important;
  margin-top: 20px !important;
  padding: 10px !important;
  overflow-x: auto !important;
  max-width: 100% !important;
  background: rgba(0, 0, 0, 0.5) !important;
  border-radius: 8px !important;
}

.chat-widget[data-fixed-root="true"] .image-viewer-modal .thumbnail {
  width: 80px !important;
  height: 80px !important;
  border: 3px solid transparent !important;
  border-radius: 6px !important;
  overflow: hidden !important;
  cursor: pointer !important;
  flex-shrink: 0 !important;
  opacity: 0.6 !important;
  transition: all 0.3s !important;
}

.chat-widget[data-fixed-root="true"] .image-viewer-modal .thumbnail:hover {
  opacity: 0.8 !important;
  transform: scale(1.05) !important;
}

.chat-widget[data-fixed-root="true"] .image-viewer-modal .thumbnail.active {
  border-color: #057FDB !important;
  opacity: 1 !important;
  transform: scale(1.1) !important;
}

.chat-widget[data-fixed-root="true"] .image-viewer-modal .thumbnail img {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
}

.chat-widget[data-fixed-root="true"] .image-viewer-modal .image-info {
  margin-top: 15px !important;
  color: white !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  width: 100% !important;
  padding: 0 20px !important;
  font-size: 16px !important;
}

.chat-widget[data-fixed-root="true"] .image-viewer-modal .download-btn {
  color: #057FDB !important;
  text-decoration: none !important;
  padding: 8px 16px !important;
  border: 2px solid #057FDB !important;
  border-radius: 6px !important;
  transition: all 0.3s !important;
  font-weight: 500 !important;
}

.chat-widget[data-fixed-root="true"] .image-viewer-modal .download-btn:hover {
  background-color: #057FDB !important;
  color: white !important;
}

/* ========== 9. 滚动条样式 ========== */
.chat-widget[data-fixed-root="true"] .history-container::-webkit-scrollbar {
  width: 6px !important;
}

.chat-widget[data-fixed-root="true"] .history-container::-webkit-scrollbar-track {
  background: #f1f1f1 !important;
  border-radius: 3px !important;
}

.chat-widget[data-fixed-root="true"] .history-container::-webkit-scrollbar-thumb {
  background: #c1c1c1 !important;
  border-radius: 3px !important;
}

.chat-widget[data-fixed-root="true"] .history-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8 !important;
}

/* ========== 10. 动画 ========== */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* ========== 11. 响应式设计 ========== */
@media (max-width: 480px) {
  .chat-widget[data-fixed-root="true"]:not(.minimized):not(.half-screen-mode):not(.fullscreen-mode) {
    width: calc(100vw - 20px) !important;
    height: 70vh !important;
    bottom: 10px !important;
    right: 10px !important;
    max-width: calc(100vw - 20px) !important;
    max-height: 75vh !important;
  }
  
  .chat-widget[data-fixed-root="true"] .header-banner {
    height: 35px !important;
  }
  
  .chat-widget[data-fixed-root="true"] .header-btn {
    width: 24px !important;
    height: 24px !important;
    font-size: 14px !important;
  }
  
  .chat-widget[data-fixed-root="true"] .header-title {
    max-width: 80px !important;
    font-size: 12px !important;
  }
}

@media (max-width: 768px) {
  .chat-widget[data-fixed-root="true"].half-screen-mode {
    width: 90vw !important;
    height: 80vh !important;
    max-width: 90vw !important;
    max-height: 80vh !important;
  }
  
  .chat-widget[data-fixed-root="true"] .image-viewer-modal .nav-btn {
    width: 40px !important;
    height: 40px !important;
  }
  
  .chat-widget[data-fixed-root="true"] .image-viewer-modal .thumbnail {
    width: 50px !important;
    height: 50px !important;
  }
}

@media (max-width: 400px) {
  .chat-widget[data-fixed-root="true"] .header-banner {
    height: 30px !important;
  }
  
  .chat-widget[data-fixed-root="true"] .header-btn {
    width: 22px !important;
    height: 22px !important;
    font-size: 12px !important;
  }
}

/* ========== 12. 错误状态 ========== */
.chat-widget[data-fixed-root="true"] .input-container.has-error {
  border-top: 2px solid #ff4d4f !important;
}

.chat-widget[data-fixed-root="true"] .error-message {
  padding: 0.75rem 1rem !important;
  background-color: #fff2f0 !important;
  border: 1px solid #ffccc7 !important;
  border-radius: 6px !important;
  margin-bottom: 0.5rem !important;
}

.chat-widget[data-fixed-root="true"] .error-content {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  color: #ff4d4f !important;
}

.chat-widget[data-fixed-root="true"] .retry-btn {
  padding: 0.25rem 0.75rem !important;
  background-color: #ff4d4f !important;
  color: white !important;
  border: none !important;
  border-radius: 4px !important;
  cursor: pointer !important;
  font-size: 0.85rem !important;
}

.chat-widget[data-fixed-root="true"] .retry-btn:hover {
  background-color: #d9363e !important;
}
.warn-text {
  font-family: 微软雅黑;
  font-size: 9pt;
  color: orange;
}
</style>
